import React, { FC, useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CompanyEditorFieldProps } from "../../CompanyEditor.types";

import { TextField, Typography, Autocomplete } from "@components/base";
import { getTranslatedCountries } from "@helpers";

const Country: FC<CompanyEditorFieldProps> = ({ control }) => {
  const { t, i18n } = useTranslation();

  const countryList = useMemo(
    () => getTranslatedCountries(i18n.language),
    [i18n.language],
  );

  return (
    <>
      <Typography variant="body2" color="text.secondary">
        {t("common.country")}
      </Typography>
      <Controller
        name="country"
        control={control}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            options={countryList}
            getOptionLabel={(option) => option.label}
            onChange={(_event, newValue) => {
              onChange(newValue ? newValue.code : "");
            }}
            value={countryList.find((c) => c.code === value) || null}
            isOptionEqualToValue={(option, val) => option.code === val.code}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="filled"
                placeholder={t("common.country")}
              />
            )}
            fullWidth
          />
        )}
      />
    </>
  );
};

export default Country;
